import React from 'react'
import Link from 'gatsby-link'

import pic01 from '../images/pic01.jpg'
import pic0101 from '../images/pic0101.jpg'
import pic02 from '../images/pic02.jpg'
import pic0202 from '../images/pic0202.jpg'
import pic03 from '../images/pic03.jpg'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleSubmit = e => {
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'contact', ...this.state }),
    })
      .then(() => alert('Success!'))
      .catch(error => alert(error))

    e.preventDefault()
  }

  render() {
    let close = (
      <div
        className="close"
        onClick={() => {
          this.props.onCloseArticle()
        }}
      />
    )

    return (
      <div id="main">
        <article
          id="about"
          className={`${this.props.article === 'about' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">About</h2>
          <span className="image main">
            <img src={pic0101} alt="" />
          </span>
          <p>
            Once a professional guitarist, I now make cool website for big companies like Netflix and Facebook. I enjoy all things related to AI and the
            neurosciences, especially learning machines.
          </p>
          <p>Lover of my wife and two kids, fly-fishing, and guitars.</p>
          <p>
            I strongly believe you're never too old or too young to learn how to
            play the guitar while fly fishing in Idaho form a wood drift boat you carved with your bare hands.
          </p>

          {close}
        </article>

        <article
          id="work"
          className={`${this.props.article === 'work' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <div className="github">
            <h2 className="major">Work</h2>
            <ul className="icons">
              <li>
                <a
                  target="_blank"
                  href="https://github.com/jsfowles"
                  className="icon fa-github"
                >
                  <span className="label">GitHub</span>
                </a>
              </li>
            </ul>
          </div>
          <span className="image main work">
            <img src={pic0202} alt="" />
          </span>
          <h4>
            <a target="_blank" href="http://jobs.netflix.com/">
              Netflix Jobs
            </a>
          </h4>

          <p>
            Having queued up weekly sprints for the project, I helped
            development for the site from the ground up, integrating with
            services like Lever and Swiftype for a simple and useful job search
            experience. Additionally, we built a custom solution for content
            management using Contentful, allowing the Talent team to quickly and
            easily update all copy, images, and videos across the site.
          </p>
          <p>This site uses React, Next.js and Contentful</p>
          <h4>
            <a target="_blank" href="http://research.netflix.com/">
              Netflix Research
            </a>
          </h4>
          <p>
            As Netflix grows they are investing heavily in recruiting top
            scientists and engineers. Historically Netflix has not shared their
            researchy work which means top scientist and engineers are not
            likely aware of the breadth of work Netflix is doing. This why we
            built the research site, to have a central location for information
            to share with potential employees.
          </p>
          <p>This site uses React, Next.js and Contentful</p>

          {close}
        </article>

        <article
          id="projects"
          className={`${this.props.article === 'projects' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <div className="github">
            <h2 className="major">Projects</h2>
          </div>
          <h4>
            <a target="_blank" href="http://eleanor.now.sh">
              Eleanor
            </a>
          </h4>
          <p>
            I built this website in celebration of the birth of my daughter
            Eleanor, we call her Leni for short. It's an 80's theme inspired by
            movies like Drive and my favorite TV show Stranger Things.
          </p>
          <p>
            I used{' '}
            <a target="_blank" href="https://github.com/zeit/next.js">
              Next.js
            </a>{' '}
            for server side rendering and{' '}
            <a target="_blank" href="https://emotion.sh/">
              Emotion
            </a>{' '}
            for CSS in JS
          </p>
          <h4>
            <a target="_blank" href="http://testla.now.sh">
              Testla
            </a>
          </h4>
          <p>
            I've always enjoyed Tesla's website so I decided to rebuild the Hero
            section of the Roadsters home page using as little CSS as possible.
            I use this site as a sandbox for testing new CSS ideas.
          </p>
          <p>
            I used{' '}
            <a target="_blank" href="https://github.com/zeit/next.js">
              Next.js
            </a>{' '}
            and{' '}
            <a target="_blank" href="https://emotion.sh/">
              Emotion
            </a>{' '}
          </p>
          {close}
        </article>

        <article
          id="social"
          className={`${this.props.article === 'social' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Social</h2>
          <div className="social-container">
            <div className="social-container-left">
              <ul className="icons">
                <li className="social-links">
                  <a target="_blank" href="https://github.com/jsfowles">
                    <span className="label icon fa-github" />
                    <h3>Github</h3>
                  </a>
                </li>
                <li className="social-links">
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/in/jsfowles"
                  >
                    <span className="label icon fa-linkedin" />
                    <h3>LinkedIn</h3>
                  </a>
                </li>
                <li className="social-links">
                  <a target="_blank" href="http://www.instagram.com/jsfowles">
                    <span className="label icon fa-instagram" />
                    <h3>Instagram</h3>
                  </a>
                </li>
              </ul>
            </div>
            <div className="social-container-right">
              <ul className="icons">
                <li className="social-links">
                  <a target="_blank" href="http://twitter.com/js_fowles">
                    <span className="label icon fa-twitter" />
                    <h3>Twitter</h3>
                  </a>
                </li>
                <li className="social-links">
                  <a target="_blank" href="http://jsfowles.tumblr.com">
                    <span className="label icon fa-camera" />
                    <h3>Photography</h3>
                  </a>
                </li>
                <li className="social-links">
                  <a target="_blank" href="http://saltcitycycles.com">
                    <span className="label icon fa-motorcycle" />
                    <h3>Motorcycles</h3>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {close}
        </article>

        <article
          id="contact"
          className={`${this.props.article === 'contact' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Say Hello</h2>
          <p>
            <a href="mailto:jsfowles@gmail.com">jsfowles@gmail.com</a>{' '}
          </p>
          <p>
            <a href="tel:1-801-414-5331">(801) 414-5331</a>
          </p>
          {close}
        </article>
      </div>
    )
  }
}

Main.propTypes = {
  route: React.PropTypes.object,
  article: React.PropTypes.string,
  articleTimeout: React.PropTypes.bool,
  onCloseArticle: React.PropTypes.func,
  timeout: React.PropTypes.bool,
}

export default Main



// WEBPACK FOOTER //
// ./src/components/Main.js